export default __webpack_public_path__ + "static/bg-work-e5fd6db188b83f33f345449e086ef936.jpg";